import React, { forwardRef, ReactNode, JSX} from 'react';
import { Button, ButtonProps } from '../Button';

export type IconButtonProps = ButtonProps & {
  icon?: ReactNode;
  round?: boolean;
  iconSize?: number | string;
  tooltipText?: string;
  'data-testid'?: string;
  ariaLabel?: string;
  'data-tooltip-id'?: string;
  ariaChecked?: boolean;
  role?: string;
};

export const IconButton = forwardRef(function IconButton(
  props: IconButtonProps,
  ref,
): JSX.Element {
  const { icon, sx, round, iconSize = 24, onClick, ...rest } = props;
  return (
    <Button
      ref={ref}
      p={0}
      onClick={onClick}
      {...rest}
      sx={{
        fontSize: iconSize,
        width: '1.75em',
        height: '1.75em',
        ...(round ? { borderRadius: 50 } : {}),
        ...sx,
      }}
    >
      {icon}
    </Button>
  );
});
